import React from 'react';
import { useSelector } from 'react-redux';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import LoadingIndicator from 'components/shared/LoadingIndicator/LoadingIndicator';
import { getTrimmedText } from '../utils';
import './MultiStatusPanel.css';

const MAX_ERROR_MESSAGE_LENGTH = 120;

function MultiStatusPanel() {
  const currentStatusNotification = useSelector((store) => store.ui.sharedPages.statusNotification);

  const pairs = Object.entries(currentStatusNotification?.actions ?? {}).filter(
    ([, notification]) => notification != null
  );
  const donorIndex = pairs.findIndex(([, notification]) => notification.type === 'donor');

  if (donorIndex > 0) {
    [pairs[0], pairs[donorIndex]] = [pairs[donorIndex], pairs[0]];
  }

  return (
    <div id="MultiStatusPanel">
      <div id="MultiStatusPanelContent">
        {pairs.map(([key, notification], index) => (
          <MultiStatusPanelItem key={key} deviceId={key} {...notification} />
        ))}
      </div>
    </div>
  );
}

export default MultiStatusPanel;

function MultiStatusPanelItem({ id, type, deviceId, status, text, icon, errorMsg }) {
  return (
    <div role="status" className="MultiStatusPanelItemContainer">
      <div className="MultiStatusPanelItem">
        <IconAndText
          customClass={'deviceLabel'}
          img={type === 'donor' ? IconLoader.icon_donor : IconLoader.icon_service}
          text={deviceId}
        />
        <IconAndText
          customClass={'statusLabel'}
          textClass={getStatusClassName({ id, status })}
          imgClass={status === Status.PENDING ? 'rotate' : undefined}
          img={icon}
          text={status === Status.PENDING ? <LoadingIndicator text={text} /> : text}
        />
      </div>
      {errorMsg && (
        <div className="MultiStatusPanelItemErrorBox" data-tip={errorMsg}>
          {getTrimmedText(errorMsg, MAX_ERROR_MESSAGE_LENGTH)}
        </div>
      )}
    </div>
  );
}

function getStatusClassName(notification) {
  if (notification) {
    if (notification.status === Status.FAILURE) return 'errorRed';
    if (notification.id === 'disabled') return 'errorRed';
    if (notification.status === Status.PENDING && notification.id === 'pivotLocklock') return 'errorRed';
    if (notification.status === Status.SUCCESS && notification.id === 'pivotLocklock') return 'errorRed';
    if (notification.status === Status.PENDING && notification.id === 'pivotLockunlock') return 'pendingBlue';
    if (notification.status === Status.SUCCESS && notification.id === 'pivotLockunlock') return 'pendingBlue';
  }

  return undefined;
}
